var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFacilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 8.00004C17.125 10.1549 16.269 12.2216 14.7452 13.7453C13.2215 15.269 11.1549 16.125 9 16.125C6.84512 16.125 4.77849 15.269 3.25476 13.7453C1.73102 12.2216 0.875 10.1549 0.875 8.00004C0.875 4.79692 2.73516 1.87817 5.61406 0.557073C5.68865 0.522806 5.76925 0.503566 5.85128 0.500451C5.9333 0.497335 6.01513 0.510406 6.0921 0.538916C6.16908 0.567427 6.23968 0.610819 6.29988 0.666615C6.36008 0.72241 6.4087 0.789517 6.44297 0.864104C6.47724 0.938691 6.49648 1.0193 6.49959 1.10132C6.50271 1.18334 6.48964 1.26517 6.46113 1.34215C6.43261 1.41912 6.38922 1.48972 6.33343 1.54992C6.27763 1.61012 6.21052 1.65874 6.13594 1.69301C3.69922 2.81176 2.125 5.28676 2.125 8.00004C2.125 9.82341 2.84933 11.5721 4.13864 12.8614C5.42795 14.1507 7.17664 14.875 9 14.875C10.8234 14.875 12.572 14.1507 13.8614 12.8614C15.1507 11.5721 15.875 9.82341 15.875 8.00004C15.875 5.28676 14.3008 2.81176 11.8641 1.69301C11.7134 1.62381 11.5965 1.4976 11.5389 1.34215C11.4813 1.1867 11.4878 1.01474 11.557 0.864104C11.6262 0.71347 11.7524 0.596496 11.9079 0.538916C12.0633 0.481337 12.2353 0.487868 12.3859 0.557073C15.2648 1.87817 17.125 4.79692 17.125 8.00004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFacilityIcon);
export default __webpack_public_path__ + "static/media/addFacilityIcon.89bbf817e6d27a36d41f172897733e88.svg";
export { ForwardRef as ReactComponent };